import {
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import CancelIcon from "../../../assets/icons/cross-bold-icon.png";
import GlobalButton from "../../../components/button";
import { useNavigate } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("50px 24px"),
  },
  "& .MuiPaper-root": {
    width: "450px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const ConfirmContractDialog = forwardRef(({}, ref) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
    disable() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const handelSave = () => {
    navigate("/all-prospects");
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <Stack
        p={2}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          variant="h1"
          fontSize={"1.5rem"}
          fontWeight={500}
          color={"secondary.dark"}
        >
          Confirmation
        </Typography>

        <IconButton onClick={handleClose}>
          <img src={CancelIcon} alt="cancel-icon" width={25} />
        </IconButton>
      </Stack>
      <Divider />
      <DialogContent>
        <Typography variant="h6" textAlign={"center"} color={"text.coolGrey"}>
          Are your sure you enter right details
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          title={"Cancel"}
          handleClickBtn={handleClose}
          style={{
            width: 120,
            height: 40,
            borderRadius: "100px",
            color: "secondary.dark",
          }}
        />
        <GlobalButton
          variant={"custom_gradient"}
          title={"Save"}
          handleClickBtn={handelSave}
          style={{
            width: 120,
            height: 40,
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default ConfirmContractDialog;
